import { useEffect } from 'react'
import zionDebug from '@fs/zion-debug'
import { splunk } from '@fs/zion-splunk-logger'

const debug = zionDebug('zion-cms')

type LogPage = {
  queryExecuted?: boolean
  previewId?: string
  resolvedSite?: string
  relativeUrl?: string
  contentType?: string
  loading: boolean
  error?: unknown
  data?: {
    CustomPage?: ZionCMSPage
  }
}

export default function useLogPage({
  queryExecuted,
  previewId,
  resolvedSite,
  relativeUrl,
  contentType,
  loading,
  error,
  data,
}: LogPage): void {
  useEffect(() => {
    if (loading || !queryExecuted) {
      return
    }
    function log(status: string) {
      splunk.log({ status, previewId, resolvedSite, relativeUrl, contentType, loading, error })
    }
    if (data?.CustomPage?.page && debug.enabled) {
      log('success')
    } else if (!loading && !data?.CustomPage?.page) {
      log('page_not_found')
    } else if (error) {
      log('error')
    }
  }, [data?.CustomPage?.page, previewId, resolvedSite, relativeUrl, contentType, loading, error, queryExecuted])
}
